import { gql } from 'graphql-tag';

export default gql`
  query GetSegmentBreakdown($input: GetSegmentBreakdownInput!) {
    getSegmentBreakdown(input: $input) {
      season_pass
      super_fan
      regular_fan
      casual_fan
      occasional
      first_timer
      inactive
    }
  }
`;
